import { ng } from '@uirouter/angularjs/lib/angular';
import { StateService } from '@uirouter/core';
import * as angular from 'angular';
import { IPopupSettings } from '../../../../../app.common/modules/common/models';
import { NotificationService } from '../../../../../app.common/modules/common/services/notification.service';
import { PopupService } from '../../../../../app.common/modules/common/services/popup.service';
import { IActiveStaffsFilter, SortOrderEnum } from '../../../model/IActiveStaffsFilter';
import { IShopperStaffDiscountItem } from '../../../model/IPagingResultShopperStaffDiscountItem';
import { DiscountForStaffService } from '../../discount-for-staff.service';

class DiscountForStaffSpecialActiveTab implements ng.IController {
    public static $inject = ['$scope', '$translate', '$uibModal', 'notificationService', 'discountForStaffService', '$state', '$timeout', 'popupService'];

    public waiting: boolean = false;
    public total: number = 0;
    public items: IShopperStaffDiscountItem[] = [];
    public itemsLimit: number = 20;
    public canLoadMore: boolean = true;
    public isArchived: boolean = false;
    public currentDate: Date;

    public search = {
        text: '' as string
    };

    constructor(
        public $scope: ng.IScope,
        protected $translate: angular.translate.ITranslateService,
        public $uibModal: ng.ui.bootstrap.IModalService,
        public notificationService: NotificationService,
        public discountForStaffService: DiscountForStaffService,
        private $state: StateService,
        public $timeout: ng.ITimeoutService,
        private popupService: PopupService
    ) {}

    public $onInit() {
        this.isArchived = this.$state.current.name === 'app.discountForStaffs.special.archived';
        this.loadData();
        this.currentDate = new Date();
    }

    public loadData() {
        if (this.waiting || !this.canLoadMore) {
            return;
        }
        this.waiting = true;

        const filter: IActiveStaffsFilter = {
            Keyword: this.search.text,
            Archive: this.isArchived,
            Limit: this.itemsLimit,
            Offset: this.items.length,
            SortColumn: 'DiscountExpirationDate',
            SortOrder: SortOrderEnum.Ascending
        };

        this.notificationService.showWaitingMessage();

        this.discountForStaffService.getActiveStaffs(filter)
            .then((response) => {
                this.total = response.Total;
                Array.prototype.push.apply(this.items, response.Items);
                this.canLoadMore = response.Items.length === this.itemsLimit;
            })
            .catch((error) => {
                this.notificationService.showErrorMessage(error);
            })
            .finally(() => {
                this.waiting = false;
                this.notificationService.clearAll();
            });
    }

    public applySearch() {
        this.canLoadMore = true;
        this.items = [];
        this.total = 0;
        this.loadData();
   }

    public openStaffDialog = async (staff: IShopperStaffDiscountItem) => {
        if (await this.discountForStaffService.checkAccess()) {
            const operationResult: any = await this.$uibModal.open({
                component: 'addOrEditStaff',
                resolve: {
                    discountID: () => staff ? staff.ID : null
                },
                size: 'md',
                backdrop: 'static',
            }).result;
            if (operationResult === 'ok') {
                this.applySearch();
            }
        }
    }
    public archiveDiscount = async  (staff: IShopperStaffDiscountItem) => {
        if (await this.discountForStaffService.checkAccess()) {
            await this.popupService.confirm({
                okTxt: this.$translate.instant('close'),
                okClass: 'btn bg-dark12 btn-with-background-icon close-icon--tiny24',
                cancelTxt: this.$translate.instant('button_delete'),
                cancelClass: 'btn btn-with-background-icon btn-danger icon-trashcan-outline-white',
                title: this.$translate.instant('delete_staff_title'),
                content: this.$translate.instant('delete_staff_body', { staff: staff.FullName }),
                invertAction: true,
                classPopup: 'popup--redesign modal360',
            } as IPopupSettings)
            .then(() => {
                    this.notificationService.showWaitingMessage();
                    this.discountForStaffService.archiveStaff(staff.ID)
                    .then(() => {
                        this.notificationService.showSuccessMessage();
                        this.applySearch();
                    })
                    .catch((error) => this.notificationService.showErrorMessage(error))
                    .finally(() => this.$timeout(() => this.notificationService.clearAll(), 3000));
                }
            );
        }
    }

}

angular.module('naut').component('discountForStaffSpecialActiveTab', {
    template: require('./discount-for-staff-special-active-tab.component.html'),
    controller: DiscountForStaffSpecialActiveTab,
    controllerAs: 'ctrl'
});



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/discountForStaff/special-tab/active-tab/discount-for-staff-special-active-tab.component.ts